import { render, staticRenderFns } from "./UserAccountModal.vue?vue&type=template&id=34d4f821&scoped=true"
import script from "./UserAccountModal.vue?vue&type=script&lang=js"
export * from "./UserAccountModal.vue?vue&type=script&lang=js"
import style0 from "./UserAccountModal.vue?vue&type=style&index=0&id=34d4f821&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34d4f821",
  null
  
)

export default component.exports